import { render, staticRenderFns } from "./transfer-selector.vue?vue&type=template&id=5f86581e&scoped=true"
import script from "./transfer-selector.vue?vue&type=script&lang=js"
export * from "./transfer-selector.vue?vue&type=script&lang=js"
import style0 from "./transfer-selector.vue?vue&type=style&index=0&id=5f86581e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f86581e",
  null
  
)

export default component.exports